module.exports = __webpack_public_path__ + "/img/Axial-11iSeu.svg";